import OutlinedInput from '@mui/material/OutlinedInput'
import { styled } from '@mui/material/styles'

export const InputBase = styled(OutlinedInput)(({ theme }) => ({
  '& .MuiOutlinedInput-input': {
    fontFamily: theme.typography.body.fontFamily,
    fontSize: theme.typography.body.fontSize,
    fontWeight: theme.typography.body.fontWeight,
    letterSpacing: theme.typography.body.letterSpacing,
    lineHeight: theme.typography.body.lineHeight,
    textDecoration: theme.typography.body.textDecoration,
    textTransform: theme.typography.body.textTransform,
  },
  '& fieldset': {
    borderColor: theme.palette.text.main,
  },
  '&.Mui-disabled fieldset': {
    borderColor: `${theme.palette.text.disabled} !important`,
  },
  '&.Mui-focused fieldset': {
    borderColor: `${theme.palette.primary.active} !important`,
  },
}))
